import Seo from "@/components/Seo";
import Marquee from "@/components/Marquee";
import ServiceCard from "@/components/ServiceCard";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <main data-testid="services-page" className="pt-16">
      <Seo
        title="Services — Bowegans Car Care, Palani"
        siteName="Bowegans Car Care"
        description="Water wash, alloy wheels, leather seat covers, car audio, LED lighting, body kits, sunfilm and PPF — expert aftermarket fitting on NH.83, Palani."
      />
      <section className="border-b border-white/10 bg-[#0E1013]">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
          <SectionHeading
            testid="services-page-heading"
            eyebrow="Our services"
            title="Built. Fitted. Perfected."
            description="Eight specialist services under one roof on NH.83 Bypass Road, Palani. Genuine parts, factory-safe methods, and a finish we put our name on."
          />
        </div>
      </section>
      <Marquee />
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
        <div className="grid gap-6 md:grid-cols-2" data-testid="services-page-grid">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} withImage />
          ))}
        </div>
        <Reveal className="mt-16">
          <div className="border border-[#262A35] bg-[#121418] p-8 text-center">
            <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#3B82F6]">
              Not sure what your car needs?
            </p>
            <p className="mt-3 text-sm text-gray-400">
              Drive in for a free inspection or call us — we will recommend only what your vehicle actually needs.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-4">
              <a
                href="tel:+917010080038"
                data-testid="services-call-button"
                className="font-mono2 inline-block bg-[#3B82F6] px-7 py-4 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-[#2563EB]"
              >
                Call 7010080038
              </a>
              <a
                href="tel:+919042438630"
                data-testid="services-call2-button"
                className="font-mono2 inline-block border border-[#3B82F6] px-7 py-4 text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6] transition-colors hover:bg-[#3B82F6] hover:text-white"
              >
                Call 9042438630
              </a>
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
